export default __webpack_public_path__ + "static/media/ip-link-filled.7d92778c.svg";